import React from 'react';
import { LuAlertCircle, LuRefreshCw } from 'react-icons/lu';
import { useTheme } from '../context/theme-context';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Unable to load communities',
  message = 'There was a problem fetching the communities. Please try again.',
  onRetry,
  showRetry = true,
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
        isDarkMode ? 'bg-red-900/30' : 'bg-red-100'
      }`}>
        <LuAlertCircle className={`text-3xl ${
          isDarkMode ? 'text-red-400' : 'text-red-500'
        }`} />
      </div>
      
      <h3 className={`text-lg font-semibold text-center mb-2 ${
        isDarkMode ? 'text-white' : 'text-gray-900'
      }`}>
        {title}
      </h3>
      
      <p className={`text-sm text-center max-w-md mb-6 ${
        isDarkMode ? 'text-gray-400' : 'text-gray-600'
      }`}>
        {message}
      </p>
      
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <LuRefreshCw className="text-sm" />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
};

export default ErrorState;